<style>
@import './fonts/stylesheet.css';
ul {
    margin: 0;
    padding: 0;
    list-style: none;
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #404455;
    letter-spacing: 0.014em;
}
.ue_left ul li:first-child, .ue_left ul li:nth-child(2) {
    font-weight: 500;
    letter-spacing: 0.1em;
}
.ue_left ul li {
    padding-bottom: 19px;
    line-height: 1.4;
}
.ue_left ul li sup {
    line-height: 0.4;
}
.ue_table {
    width: 100%;
    font-family: Gotham Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 11px;
    color: #404455;
}
.ue_table td {
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>
<script>
    export let track
    let l = "0мм"
    let h = "0мм"
    let w = "0мм"
    if (track.length) {
        l = track.length + "мм"
    }
    if (track.height) {
        h = track.height + "мм"
    }
    if (track.width) {
        w = track.width + "мм"
    }
</script>
<table class="ue_table">
    <tr>
        <td>Длина:</td>
        <td>{track.length} мм</td>
    </tr>
    <tr>
        <td>Ширина:</td>
        <td>{track.width} мм</td>
    </tr>
    <tr>
        <td>Высота:</td>
        <td>{track.height} мм</td>
    </tr>
    <tr>
        <td>Средний вес:</td>
        <td>{track.weight} кг</td>
    </tr>
    <tr>
        <td>Внутрення площадь:</td>
        <td>{track.square} м<sup>2</sup></td>
    </tr>
    <tr>
        <td>Клиренс:</td>
        <td>{track.clearance} мм</td>
    </tr>
</table>
